export default __webpack_public_path__ + "static/media/02.2fd3abe1.png";